/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { Button, Paper } from '@mui/material';
import RHFSelect from 'src/components/elements/Select/RHFSelect';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import RHFTextArea from 'src/components/elements/TextArea/RHFTextArea';
import useYupValidationResolver from 'src/hooks/useYupValidationResolver';
import * as yup from 'yup';
import { useInterviewPositions } from 'src/hooks/query/interviewPositions';
import RHFAutoComplete from 'src/components/elements/AutoComplete/RHFAutoComplete';
import { Loader } from 'src/components';
import { ConfigureInterviewProps, ConfigureInterviewValues } from '../../types';

const ConfigureInterview = function ConfigureInterview(props: ConfigureInterviewProps) {
  const {
    jobOrderId,
    interviewPositionId,
    updateInterviewPosition,
    close,
  } = props;

  const {
    interviewPositionsOptions,
    interviewPositionsLoading,
    fetchInterviewPositions,
  } = useInterviewPositions();

  const [loading, setLoading] = useState<boolean>(false);

  const validationSchema = yup.object().shape({
    configurePosition: yup.string().typeError('Select interview position to change').required('Interview Position required'),
  });

  const resolver = useYupValidationResolver(validationSchema);

  const methods = useForm<ConfigureInterviewValues>({
    resolver,
    defaultValues: {
      configurePosition: interviewPositionId,
    },
  });

  const { handleSubmit } = methods;

  const submitHandler: SubmitHandler<ConfigureInterviewValues> = async (data) => {
    try {
      const finalData = {
        ...data,
        jobOrderId,
      };
      if (updateInterviewPosition) {
        setLoading(true);
        await updateInterviewPosition(finalData, close);
        setLoading(false);
      }
    } catch (e) {
      console.info('...');
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submitHandler)}>
        <Paper
          className="px-4 rounded-md text-left relative"
          elevation={0}
        >
          <div className="pb-1 text-secondary text-center text-lg font-bold">
            Configure Interview Position
          </div>
          <div className="pb-8 pt-4">
            <div className="pb-8 flex flex-col gap-4">
              <div className="min-w-[200px]">
                <RHFAutoComplete
                  name="configurePosition"
                  control={methods.control}
                  options={interviewPositionsOptions}
                  loading={interviewPositionsLoading}
                  placeholder="Configure interview position to"
                />
              </div>
            </div>
            <div className="flex gap-2">
              <Button
                type="submit"
                variant="contained"
                size="large"
              >
                Configure
              </Button>
              <Button
                variant="outlined"
                size="large"
                onClick={close}
              >
                Cancel
              </Button>
            </div>
          </div>
          {loading && (
          <div className="absolute top-[25%] left-[40%]">
            <Loader />
          </div>
          )}
        </Paper>
      </form>
    </FormProvider>
  );
};

export default ConfigureInterview;
